import { Component } from '@angular/core';
import {RouterLink} from "@angular/router";

@Component({
    selector: 'app-notfound',
    imports: [
        RouterLink
    ],
    templateUrl: './notfound.component.html',
    standalone: true
})
export class NotfoundComponent { }
